// extracted by mini-css-extract-plugin
export var active = "card-module--active--bv1xx";
export var card = "card-module--card--VdP60";
export var cardLink = "card-module--card-link--eBT4u";
export var logo = "card-module--logo--jloz6";
export var text = "card-module--text--U1wAU";